class Devices {
    id: string;
    type: "washer" | "dryer" | "combo";
    name: string;
    status: "error" | "standby" | "inUse" | "offline";
    courseName: string | undefined;
    remainTime: string | undefined;
    model: string;
    dryType: "nonHeater" | "heater" | "dryer";
    cycle: number;

    constructor({
        id,
        type,
        name,
        status,
        courseName,
        remainTime,
        model,
        dryType,
        cycle,
    }: {
        id: string;
        type: "washer" | "dryer" | "combo";
        name: string;
        status: "error" | "standby" | "inUse" | "offline";
        courseName: string | undefined;
        remainTime: string | undefined;
        model: string;
        dryType: "nonHeater" | "heater" | "dryer";
        cycle: number;
    }) {
        this.id = id;
        this.type = type;
        this.name = name;
        this.status = status;
        this.courseName = courseName;
        this.remainTime = remainTime;
        this.model = model;
        this.dryType = dryType;
        this.cycle = cycle;
    }
}

export default Devices;
